import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstStockInsumo = () => import('./Index')
const DashboardVisualFeedlot = () => import('./DashBoardVisual.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_analisis_feedlot',
        name: 'Análisis Feedlot',
        component: ViewLstStockInsumo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'lst_analisis_feedlot/dashboard_visual',
        name: 'DashboardVisualFeedlot',
        component: DashboardVisualFeedlot,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router